import { keymap } from "prosemirror-keymap";
import { undo, redo, history } from "prosemirror-history";
import { undoInputRule } from "prosemirror-inputrules";
import { selectParentNode, splitBlockAs } from "prosemirror-commands";
import { insertHardBreak, enterCommand, backspaceCommand, toggleBoldCommand, toggleItalicsCommand, toggleUnderlineCommand } from "../commands/custom-commands";
import { sinkListItem, liftListItem } from "prosemirror-schema-list";
import { customSchema } from "../schemas/custom-schema";
import { Selection } from "prosemirror-state";

const mac = typeof navigator != "undefined" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : false

function arrowHandler(dir) {
  return (state, dispatch, view) => {
    /*const { selection, tr, doc } = state,
      { $cursor } = selection;
 
    if(!cursor) {
      return false;
    }

    const { nodeAfter } = $cursor;

    if(nodeAfter && nodeAfter.type.name === "note") {
      if(dispatch) {
        const newPos = dir === "right" || dir === "up" ? $cursor.pos + $cursor.nodeAfter.nodeSize : $cursor.pos - $cursor.nodeBefore.nodeSize

        dispatch(
          tr.setSelection(
            TextSelection.create(doc, $cursor.pos  + )
          )
        );
      }
    }*/
    let { empty, $head } = state.selection,
      { doc, tr } = state;

    if($head.depth === 0) {
      return false;
    }

    if($head.parentOffset === 0 && $head.depth > 0) {
      const posBefore = $head.before($head.depth);
      if(posBefore === 0) {
        return false;
      }
    }

    if(empty || view.endOfTextblock(dir)) {
      let side = dir === "left" || dir === "up" ? -1 : 1,
        nextPos = Selection.near(doc.resolve(side > 0 ? $head.after() : $head.before()), side);
      if(!!nextPos.$head && nextPos.$head.parent.type.name === "note") {
        dispatch(tr.setSelection(nextPos));

        return true;
      }
    }

    return false;
  }
}

export const customKeymap = keymap({
  "Escape": selectParentNode,
  "Enter": enterCommand,
  "Shift-Enter": insertHardBreak,
  "Mod-Enter": insertHardBreak,
  "Ctrl-z": undo,
  "Mod-z": undo,
  "Shift-Mod-z": redo,
  "Ctrl-y": redo,
  "Ctrl-Shift-z": redo,
  "Ctrl-b": toggleBoldCommand,
  "Ctrl-B": toggleBoldCommand,
  "Mod-b": toggleBoldCommand,
  "Mod-B": toggleBoldCommand,
  "Ctrl-i": toggleItalicsCommand,
  "Ctrl-I": toggleItalicsCommand,
  "Mod-i": toggleItalicsCommand,
  "Ctrl-u": toggleUnderlineCommand,
  "Ctrl-U": toggleUnderlineCommand,
  "Mod-u": toggleUnderlineCommand,
  "Mod-U": toggleUnderlineCommand,
  "Backspace": backspaceCommand,
  "Mod-Backspace": backspaceCommand,
  "Tab": sinkListItem(customSchema.nodes.listItem),
  "Shift-Tab": liftListItem(customSchema.nodes.listItem),
  "ArrowLeft": arrowHandler("left"),
  "ArrowRight": arrowHandler("right"),
  "ArrowUp": arrowHandler("up"),
  "ArrowDown": arrowHandler("down")
});
